export const MenuItems = [
  {
    title: "All Blogs",
    url: "/allBlogs",
  },
  {
    title: "Add Blog",
    url: "/addBlogs",
  },
  {
    title: "All Separation Feedback",
    url: "/allFeedback",
  },
  {
    title: "User Interests",
    url: "/userInterests",
  },
  {
    title: "All Users",
    url: "/allUsers",
  },
   {
    title: "Paypal Payments",
    url: "/paypal",
  },
 
  {
    title:"Android Subscription Payments",
    url:"/android"
  },
   {
    title:"iOS Subscription Payments",
    url:"/ios"
  },
   {
    title: "WebApp Data",
    url: "/webapp",
  },
  {
    title: "Coins Report",
    url: "/coinsreport",
  }, 
  {
    title: "All Lesson Categories",
    url: "/allLessonCategories",
  },
  {
    title: "All Lessons",
    url: "/allLessons",
  },
  {
    title: "Coins Consumption Report",
    url: "/coinsconsumptionreport",
  },
   {
    title: "Add FAQ",
    url: "/addFaq",
  },
  {
    title: "All FAQ",
    url: "/allFaq",
  },
  {
    title: "Get Image Link",
    url: "/getLink",
  },
  {
    title: "Merge UID",
    url: "/MergeUid",
  },
];
